<template>
  <div class>
    <section class="d-flex flex-column h-full">
      <!-- <div class="fixed-header w-full"> -->
      <TopAppBar
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="''"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        staticMode="true"
      ></TopAppBar>
    </section>
      <div class="certificate h-full-over bg-white" v-if="certificateData && certificateData.printType && certificateData.printType.value=='HEIGHT'">
        <div class="content">
          <div class="card">
            <div class="card_bg"><img :src="certificateData.image" alt=""></div>
            <div class="con">
              <p class="tit">{{certificateData?certificateData.name:''}}</p>
              <p class="name" v-if="certificateData && certificateData.params && certificateData.params.MEMBER_NAME">{{certificateData.params.MEMBER_NAME}}</p>
              <div class="br"></div>
              <div class="txt">
                <p v-if="certificateData && certificateData.params && certificateData.params.BELONG">{{certificateData.params.BELONG}}</p>
                <p v-if="certificateData && certificateData.params && certificateData.params.DEGREE_NAME">{{certificateData.params.DEGREE_NAME}}</p>
                <p v-if="certificateData && certificateData.params && certificateData.params.CONTENTS" v-html="certificateData.params.CONTENTS"></p>
              </div>
              <div class="tail">
                <p v-if="certificateData && certificateData.params && certificateData.params.ISSUE_DATE">{{$moment.unix(certificateData.params.ISSUE_DATE/1000).format("YYYY. MM. DD")}}</p>
                <p v-if="certificateData && certificateData.params && certificateData.params.ISSUE_ORGANIZATION_NAME">{{certificateData.params.ISSUE_ORGANIZATION_NAME}}</p>
              </div>
            </div>
          </div>
            <!-- <div class="btn_wrap">
              <a href="#" class="btn">수료증 공유하기</a>
            </div> -->
      </div>
    </div>

      <div class="certificate h-full-over bg-white" v-if="certificateData && certificateData.printType && certificateData.printType.value=='WIDTH'">
        <div class="content">
          <div class="card horizontal">
            <div class="card_bg"><img :src="certificateData.image" alt=""></div>
            <div class="con">
              <p class="tit">{{certificateData?certificateData.name:''}}</p>
              <p class="name" v-if="certificateData && certificateData.params && certificateData.params.MEMBER_NAME">{{certificateData.params.MEMBER_NAME}}</p>
              <div class="br"></div>
              <div class="txt">
                <div class="left" v-if="certificateData && certificateData.params && certificateData.params.BELONG">{{certificateData.params.BELONG}}</div>
                <div class="right" v-if="certificateData && certificateData.params && certificateData.params.DEGREE_NAME">{{certificateData.params.DEGREE_NAME}}</div>
              </div>
              <div class="tail" v-if="certificateData && certificateData.params && certificateData.params.CONTENTS" v-html="certificateData.params.CONTENTS"></div>
              <div class="date">
                <p class="left" v-if="certificateData && certificateData.params && certificateData.params.ISSUE_DATE">{{$moment.unix(certificateData.params.ISSUE_DATE/1000).format("YYYY. MM. DD")}}</p>
                <p class="right" v-if="certificateData && certificateData.params && certificateData.params.ISSUE_ORGANIZATION_NAME">{{certificateData.params.ISSUE_ORGANIZATION_NAME}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import rewardApi from "@/api/rewardApi.js";
export default {
  name: "CertificateDetail",
  data() {
    return {
      title: "",
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      certificateData: null,
      certificate: null,
    };
  },
  filters: {
    charLength(value) {
      if (value.length > 30) {
        return value.substring(0, 30) + "..";
      } else {
        return value;
      }
    },
  },
  components: {
    TopAppBar,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },
  mounted() {
    let id = this.$router.currentRoute.params.id;
    this.setTopAppBarBackReward();
    this.fetchData(id);
  },
  methods: {
    fetchData(id) {
      let parmas = { id:id };
      rewardApi
        .certificateDetail(id)
        .then((response) => {
          console.log("responseBadge", response);
          this.certificateData = response.data.data;
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
/* reset */
		.certificate *{margin:0; padding:0; font-family:'Noto Sans KR', Arial, dotum, sans-serif; font-weight:normal; font-size:13px;}
		ol, ul, li{list-style:none;}
		table{width:100%; border-collapse:collapse; border-spacing:0; table-layout:fixed;}
		th{font-weight:normal;}
		form, fieldset, iframe{display:block; border:0;}
		img, button{border:none; vertical-align:middle;}
		hr{height:0; display:none;}
		i, em, address{font-style:normal;}
		label, button{cursor:pointer;}
		blockquote, q{quotes:none;}
		caption, .hide{visibility:hidden; width:0; height:0; padding:0; margin:0; font-size:0; text-indent:-9999em;}
		legend{overflow:hidden; visibility:hidden; position:absolute; width:0; height:0; padding:0; margin:0; font-size:0; text-indent:-100%; white-space:nowrap; z-index:-1;}
		input[type="text"], input[type="password"], input[type="email"], input[type="search"], input[type="image"], input[type="tel"], textarea{-webkit-appearance:none; -webkit-border-radius:0}
		input:focus{outline:none}
		::-webkit-input-placeholder{color:#999;}
		::-moz-selection{background:#005aab; color:#fff; text-shadow:none;}
		::-webkit-selection{background:#005aab; color:#fff; text-shadow:none;}
		a{color:#222; text-decoration:none;}
		a:link, a:visited {text-decoration:none;}
		button{display:inline-block; background:none; border:none; outline:none}
		::selection{background:#005aab; color:#fff; text-shadow:none;}
		
		/* style */
		.certificate{position:relative;}
    .land-scap-color{color:#222;}
		.certificate .content{position:relative; padding:20px 20px}
		.card{position:relative; box-sizing:border-box; background:#fff; margin:0 auto; width:292px; height:auto}
		.card_bg img{width:292px; height:100%;}
		.card .con{position:relative; left:0; top:0; box-sizing:border-box; margin:5px 15px; padding:80px 0 20px 0; text-align:center; line-height:1.4;}
		.card .con .tit{font-weight:bold; position:relative; font-size:14px;}
		.card .con .name{font-weight:bold; position:relative; font-size:18px; padding:20px 0 0 0; letter-spacing:1px}
		.card .con .br{width:120px; height:1px; background:#e0cb9f; margin:15px auto}
		.card .con .txt{position:relative; font-size:13px; color:#818181}
		.card .con .txt p{position:relative; margin-bottom:10px;}
		.card .con .txt p:nth-last-child(1){margin-bottom:0}
		.card .con .tail{position:relative; padding:40px 0 20px 0; font-size:13px; color:#818181}
		.card .con .tail p{position:relative; margin-bottom:10px}
		.card .con .tail p:nth-last-child(1){margin-bottom:0}
		.btn_wrap{position:relative; padding:20px 0 0 0}
		.btn_wrap .btn{display:block; margin:0 auto; color:#fff; border-radius:4px; font-size:14px; letter-spacing:1px; font-weight:500; background:#fc5356; text-align:center; padding:10px 0; box-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.2); max-width:360px;}
		.card.horizontal{width:312px; height:100%;}
		.card.horizontal .card_bg img{width:312px; height:100%}
		.card.horizontal .con{padding:50px 0 0 0}
		.card.horizontal .con .name{font-size:15px; padding:10px 0 0 0}
		.card.horizontal .con .tit{font-size:10px; font-weight:normal}
		.card.horizontal .con .br{width:200px; margin:8px auto}
		.card.horizontal .con .txt{font-size:0; max-width:220px; margin:0 auto}
		.card.horizontal .con .txt div{display:inline-block; width:50%; vertical-align:top; font-size:10px; color:#818181}
		.card.horizontal .con .tail{font-size:10px; color:#212121; padding:12px 0 0 0}
		.card.horizontal .con .date{position:relative; padding:20px 0 20px 0; overflow:hidden;}
		.card.horizontal .con .date p{font-size:10px; color:#818181}
		.card.horizontal .con .date .left{float:left}
    .card.horizontal .con .date .right{float:right}
    .card_bg { position: absolute;left: 0;top: 0;width: 100%;height: 100%;}
    @media (orientation: landscape) {
      .d-landscape-none {
        display: none !important;
      }

      .d-landscape-block {
        display: block !important;
      }
    }

    @media (orientation: portrait) {
      .d-portrait-none {
        display: none !important;
      }

      .d-portrait-block {
        display: block !important;
      }
    }
    .h-full-over {
      height: 100vh;
    }
</style>